<template>
  <div>
    <el-tabs v-model="activeName" :stretch="true" type="card" @tab-click="handleActiveName">
      <el-tab-pane v-for="item in tabLabel" :key="item.name" :name="item.name">
        <span slot="label">
          {{ item.label }}
          <span v-if="item.label === '商品审核'" class="count">
            {{ auditSkuCount <= 99 ? auditSkuCount : '···' }}
          </span>
        </span>
        <div>
          <!-- component 组件方法这里 对应组件的mounted 会调用两次 为什么? -->
        </div>
      </el-tab-pane>
    </el-tabs>
    <component :is="activeName" :agreement-id="agreementId" @countRefresh="getQueryAuditSkuCount"></component>
  </div>
</template>

<script>
// 协议商品
/* import CollectGoods from './components/collectGoods.vue'; */
// 商品审核
import Api from '@/modules/projectA/api/agreement/index';
import GoodsAudit from './components/goodsAudit.vue';
import CollectAgreementManage from './components/collectAgreementManage';

export default {
  name: 'GoodsManagement',
  components: { CollectAgreementManage, GoodsAudit },
  data() {
    return {
      tabLabel: [
        { label: '协议商品', name: 'CollectAgreementManage' },
        { label: '商品审核', name: 'GoodsAudit' },
      ],
      activeName: 'CollectAgreementManage',
      auditSkuCount: 0,
    };
  },
  created() {
    this.agreementId = this.$route.query.agreementId;
    this.getQueryAuditSkuCount();
  },
  methods: {
    handleActiveName(val) {
      console.log(val);
    },
    async getQueryAuditSkuCount() {
      const result = await Api.queryAuditSkuCount({
        agreementId: this.agreementId,
      });
      if (result.code === '200') {
        this.auditSkuCount = result.data;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.count {
  position: relative;
  top: -5px;
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 15px;
  line-height: 15px;
  background: #f0250f;
  color: #fff;
  overflow: hidden;
  font-size: 10px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #f4f7ff !important;
  line-height: 40px;
  border-bottom: 1px solid #e4e7ed;
  color: #2587ff !important;
  &::before {
    content: '';
    width: 100%;
    height: 2px;
    background: rgb(37, 135, 255);
    position: absolute;
    left: 0;
    top: -1px;
  }
}
::v-deep .el-tabs__header {
  margin: 0;
}
::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}
::v-deep .el-tabs__item {
  line-height: 40px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed !important;
  color: #333333 !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-radius: 0;
}
.data-btn {
  margin: 10px 10px 10px 0;
}
</style>
